// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#embedded-service #esw-fab {
    width: 67px !important;
    height: 67px !important;
    z-index: 99999999 !important;
}

.embedded-service .channelmenu_header>h2 {
    line-height: 40px !important;
}

#esw-menu-opened-fab-icon .esw-custom_icon {
    width: 22px !important;
}

.embedded-service .fab div[class="icon_fab_container"]>img.esw-custom_icon {
    width: 27px !important;
}

.embedded-service>#esw-modaloverlay.isMaximized+div#esw-container>div.channelmenu {
    z-index: 99999999 !important;
}

@media (max-width: 650px) {
    #embedded-service #esw-fab {
        width: 56px !important;
        height: 56px !important;
    }

    .embedded-service .channelmenu_header>h2 {
        line-height: 32px !important;
        font-size: 20px !important;
    }

    #esw-menu-opened-fab-icon .esw-custom_icon {
        width: 18px !important;
    }

    .embedded-service .fab div[class="icon_fab_container"]>img.esw-custom_icon {
        width: 22px !important;
    }
}`, "",{"version":3,"sources":["webpack://./laurastar/app/static/css/chatbot.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["#embedded-service #esw-fab {\n    width: 67px !important;\n    height: 67px !important;\n    z-index: 99999999 !important;\n}\n\n.embedded-service .channelmenu_header>h2 {\n    line-height: 40px !important;\n}\n\n#esw-menu-opened-fab-icon .esw-custom_icon {\n    width: 22px !important;\n}\n\n.embedded-service .fab div[class=\"icon_fab_container\"]>img.esw-custom_icon {\n    width: 27px !important;\n}\n\n.embedded-service>#esw-modaloverlay.isMaximized+div#esw-container>div.channelmenu {\n    z-index: 99999999 !important;\n}\n\n@media (max-width: 650px) {\n    #embedded-service #esw-fab {\n        width: 56px !important;\n        height: 56px !important;\n    }\n\n    .embedded-service .channelmenu_header>h2 {\n        line-height: 32px !important;\n        font-size: 20px !important;\n    }\n\n    #esw-menu-opened-fab-icon .esw-custom_icon {\n        width: 18px !important;\n    }\n\n    .embedded-service .fab div[class=\"icon_fab_container\"]>img.esw-custom_icon {\n        width: 22px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
